import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Box, Button, } from "@mui/material";
import Grid from '@mui/material/Grid';
import { ShoppingCartItem } from 'common-models';
import { FC } from 'react';
import { Configuration } from '../../Configuration';
import { useChangeProductQuantityMutation } from '../../features/events/eventShopApiSlice';
import { useGetSingleEventPhotoQuery } from '../../features/events/eventsApiSlice';
import { VisitorState } from '../../features/visitor/visitorSlice';

type MiniCartItemProps = {
    cartItem: ShoppingCartItem,
    visitor: VisitorState;
}

const MiniCartItem: FC<MiniCartItemProps> = ({ cartItem, visitor }) => {
    const { data: eventPhoto = undefined } =
        useGetSingleEventPhotoQuery({ eventId: cartItem.eventId, imageId: cartItem.imageId });

    const [changeProductQuantity] = useChangeProductQuantityMutation();


    const getEventImageUrl = (eventId: string, imageId: string): string => {
        return eventPhoto !== undefined ? `${Configuration.StaticSiteUrl}/events/${eventId}/${imageId}-${eventPhoto.webSizes[0].width}.jpg` : '';
    }

    const changeItemQuantity = async (itemId: string, delta: number) => {
        await changeProductQuantity({
            visitorId: visitor.identifier,
            request: {
                type: 'change-quantity',
                request: {
                    delta: delta,
                    eventId: cartItem.eventId,
                    imageId: cartItem.imageId,
                    productId: cartItem.product.productId
                }
            }
        });
    }

    const deleteItem = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        changeItemQuantity(event.currentTarget.value, -cartItem.quantity);
    }

    function getPrice(item: ShoppingCartItem) {
        const priceInSekExclVat = item.priceInSekExclVat;
        return priceInSekExclVat * 1.25;
    }

    function getPriceSpecification(cartItem: ShoppingCartItem): string {
        const price = cartItem.product.prices.find(x => x.id === cartItem.appliedPriceId);
        if (price !== undefined) {
            return `${price.quantity} för ${price.priceInSekExclVat * 1.25}`;
        }
        return '(det här är konstigt)';
    }

    return (

        <Box key={cartItem.id} className='minicart-item-frame'>
            <Grid container>
                <Grid size="auto" className='minicart-image-frame'>
                    <img
                        alt={cartItem.imageId}
                        className='minicart-image'
                        src={getEventImageUrl(cartItem.eventId, cartItem.imageId)} />
                </Grid>
                <Grid size="grow" className='minicart-item-specification'>
                    <Grid
                        size="auto"
                        className='minicart-item-price'>
                        <Grid size="auto" >
                            {getPrice(cartItem)}
                            <br />
                            <Box className='minicart_item-price-specification'>
                                {getPriceSpecification(cartItem)}
                            </Box>

                        </Grid>
                    </Grid>
                    <Grid
                        className='minicart-item-tools'
                        size="auto">
                        <Button
                            variant='text'
                            onClick={deleteItem}
                            value={cartItem.id}
                        >
                            <DeleteForeverIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export { MiniCartItem };
